import { tv } from "tailwind-variants";
const autocompleteListItemVariants = tv({
    slots: {
        itemWrapperSlot: 'bg-neutral-1 flex h-16 justify-between gap-2 rounded-lg border-2 border-transparent p-2',
        leftNodeAndTextSlot: 'flex gap-2',
        leftNodeIconWrapperSlot: 'my-auto flex h-12 w-12 shrink-0 items-center justify-center rounded-lg',
        textSlot: 'my-auto flex flex-col px-1',
        rightNodeSlot: 'my-auto',
        groupHeaderWrapper: 'h-8 pb-1 pl-3 pt-2'
    },
    variants: {
        isHighlighted: {
            true: {
                itemWrapperSlot: 'bg-primary-2'
            }
        },
        isSelected: {
            true: {
                itemWrapperSlot: 'bg-primary-3'
            }
        },
        isIndented: {
            true: {
                leftNodeAndTextSlot: 'pl-6'
            }
        },
        isHighlightedIndexWithKeyArrow: {
            true: {
                itemWrapperSlot: 'border-primary-8 border-2'
            }
        }
    },
    compoundVariants: [
        {
            isSelected: true,
            isHighlighted: true,
            class: {
                itemWrapperSlot: 'bg-primary-4'
            }
        }
    ],
    defaultVariants: {
        isHighlighted: false,
        isSelectedItem: false
    }
});
export { autocompleteListItemVariants };
